import { usePersistFilters } from "../../../hooks/usePersistFilters";

export const useGetFilters = () => {

    const { filters, handleChangeFilters } = usePersistFilters({
        nombre: '',
        apellido: '',
        codigoSap: "",
        dni: "",
        afiliado: ""
    }, `buscarPacienteFilters`);

    return {
        filters,
        handleChangeFilters,
    };
};